enum SCRIPT_STATUS {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}
export default SCRIPT_STATUS;
